var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorEdify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 50.1C33.3 48.9954 34.1954 48.1 35.3 48.1H38.7C39.8046 48.1 40.7 48.9954 40.7 50.1V53.5C40.7 54.6046 39.8046 55.5 38.7 55.5H35.3C34.1954 55.5 33.3 54.6046 33.3 53.5V50.1ZM33.3 20.5C33.3 19.3954 34.1954 18.5 35.3 18.5H38.7C39.8046 18.5 40.7 19.3954 40.7 20.5V38.7C40.7 39.8046 39.8046 40.7 38.7 40.7H35.3C34.1954 40.7 33.3 39.8046 33.3 38.7V20.5ZM37 0C16.539 0 0 16.65 0 37C0 46.813 3.8982 56.2241 10.837 63.163C14.2728 66.5987 18.3517 69.3241 22.8407 71.1835C27.3298 73.043 32.1411 74 37 74C46.813 74 56.2241 70.1018 63.163 63.163C70.1018 56.2241 74 46.813 74 37C74 32.1411 73.043 27.3298 71.1835 22.8407C69.3241 18.3517 66.5987 14.2728 63.163 10.837C59.7272 7.40128 55.6483 4.67588 51.1593 2.81646C46.6702 0.957034 41.8589 0 37 0ZM37 66.6C29.1496 66.6 21.6207 63.4814 16.0696 57.9304C10.5186 52.3793 7.4 44.8504 7.4 37C7.4 29.1496 10.5186 21.6207 16.0696 16.0696C21.6207 10.5186 29.1496 7.4 37 7.4C44.8504 7.4 52.3793 10.5186 57.9304 16.0696C63.4814 21.6207 66.6 29.1496 66.6 37C66.6 44.8504 63.4814 52.3793 57.9304 57.9304C52.3793 63.4814 44.8504 66.6 37 66.6Z",
    fill: "#B0BACC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorEdify);
export default __webpack_public_path__ + "static/media/vectorEdify.3c2e9aa75fceff2e07a11bc545bacfad.svg";
export { ForwardRef as ReactComponent };